import { SCREENS, REDUX_ACTIONS, GAME_ID } from 'a/allAboard/data/constants';

const initState = {
  currentScreen: SCREENS.LOADING,
};

// This reducer stores that data for which screen is shown during all aboard

const screenReducer = (state = initState, { type, payload, gameId }) => {
  if (type === 'SELECT_ACTIVITY' && payload.activity === GAME_ID) {
    return initState;
  }

  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    // change screen according to action payload
    case REDUX_ACTIONS.CHANGE_SCREEN:
      return {
        currentScreen: payload,
      };
    default:
      return state;
  }
};

export default screenReducer;
